import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { pipe, switchMap, tap, toArray } from 'rxjs';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { DrawService, ProfileDrawProjection } from '@unicup-ticketing/service';
import { tapResponse } from '@ngrx/operators';

export const ProfileUserDrawsStateStore = signalStore(
  withState({
    isLoading: false,
    isError: false,
    profileDrawOverview: undefined as ProfileDrawProjection[] | undefined,
  }),
  withMethods((store, service = inject(DrawService)) => ({
    refresh: rxMethod<void>(
      pipe(
        tap(() => patchState(store, { isLoading: true })),
        switchMap(() =>
          service.retrieveUserProfileDraws().pipe(
            toArray(),
            tapResponse({
              next: draws =>
                patchState(store, {
                  isLoading: false,
                  profileDrawOverview: draws,
                }),
              error: error => {
                patchState(store, { isLoading: false, isError: true });
                console.log(error);
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
